import Axios from 'axios';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';

const state = {
  subscribedCountryCodes: [],
  isBusy: false,
  error: null
};

const getters = {
  subscribedCountries: (state, getters, rootState, rootGetters) => {
    const countries = rootGetters['countries/countries'] || [];

    return state.subscribedCountryCodes.map(countryCode => {
      const country = countries.find(c => c.alpha_2_code === countryCode);

      return country ? {
        id: country.id,
        alpha_2_code: country.alpha_2_code,
        name: country.name
      } : {
        id: null,
        alpha_2_code: countryCode,
        name: i18n.t('country.subscription.unknown_country', { code: countryCode })
      };
    });
  }
};

const mutations = {
  LOAD_COUNTRY_SUBSCRIPTIONS_BUSY: (state, payload) => {
    state.isBusy = payload;
  },
  LOAD_COUNTRY_SUBSCRIPTIONS_SUCCESS: (state, payload) => {
    state.subscribedCountryCodes = payload || [];
    state.error = null;
  },
  LOAD_COUNTRY_SUBSCRIPTIONS_FAIL: (state, payload) => {
    state.subscribedCountryCodes = [];
    state.error = payload;
  },
  ADD_COUNTRY_SUBSCRIPTION_SUCCESS: (state, countryCode) => {
    if (!state.subscribedCountryCodes.includes(countryCode)) {
      state.subscribedCountryCodes = [...state.subscribedCountryCodes, countryCode];
    }
    state.error = null;
  },
  REMOVE_COUNTRY_SUBSCRIPTION_SUCCESS: (state, countryCode) => {
    state.subscribedCountryCodes = state.subscribedCountryCodes.filter(code => code !== countryCode);
    state.error = null;
  },
  COUNTRY_SUBSCRIPTION_FAIL: (state, payload) => {
    state.error = payload;
  }
};

const actions = {
  loadSubscribedCountries: ({ commit, rootState }, { projectId }) => {
    commit('LOAD_COUNTRY_SUBSCRIPTIONS_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };

    return Axios.get(`${API_HOST}/projects/${projectId}/country_subscriptions`, config)
      .then(response => {
        commit('LOAD_COUNTRY_SUBSCRIPTIONS_SUCCESS', response.data.data || []);
        return response.data;
      })
      .catch(error => {
        console.error('Failed to load subscribed countries:', error);
        commit('LOAD_COUNTRY_SUBSCRIPTIONS_FAIL', error);
      })
      .finally(() => commit('LOAD_COUNTRY_SUBSCRIPTIONS_BUSY', false));
  },

  addCountryToProject: ({ commit, rootState }, { projectId, countryCode }) => {
    commit('LOAD_COUNTRY_SUBSCRIPTIONS_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };

    return Axios.post(
      `${API_HOST}/projects/${projectId}/country_subscriptions`,
      { country_code: countryCode },
      config
    )
      .then(response => {
        commit('ADD_COUNTRY_SUBSCRIPTION_SUCCESS', countryCode);
        return response.data;
      })
      .catch(error => {
        console.error('Failed to add country:', error);
        commit('COUNTRY_SUBSCRIPTION_FAIL', error);
        throw error;
      })
      .finally(() => commit('LOAD_COUNTRY_SUBSCRIPTIONS_BUSY', false));
  },

  removeCountryFromProject: ({ commit, rootState }, { projectId, countryCode }) => {
    commit('LOAD_COUNTRY_SUBSCRIPTIONS_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };

    return Axios.delete(
      `${API_HOST}/projects/${projectId}/country_subscriptions/${countryCode}`,
      config
    )
      .then(response => {
        commit('REMOVE_COUNTRY_SUBSCRIPTION_SUCCESS', countryCode);
        return response.data;
      })
      .catch(error => {
        console.error('Failed to remove country:', error);
        commit('COUNTRY_SUBSCRIPTION_FAIL', error);
        throw error;
      })
      .finally(() => commit('LOAD_COUNTRY_SUBSCRIPTIONS_BUSY', false));
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
